// Netherlands Regex
export const COMPANY_PHONE_VALIDATION_REGEX = /^[0-9+ ]{9,}$/;
export const KVK_NUMBER_VALIDATION_REGEX = /^[0-9]{8}$/;
export const NL_VAT_NUMBER_VALIDATION_REGEX = /^NL\d{9}B\d{2}$/;

// Germany Regex
export const HRB_NUMBER_VALIDATION_REGEX =
  /^[A-Za-z]{2,3}\d{1,6}[A-Za-z]{0,5}(-[A-Za-z]\d{4})?$/;
export const DE_VAT_NUMBER_VALIDATION_REGEX = /^DE\s?[0-9]{9}$/;
export const DE_TAX_NUMBER_VALIDATION_REGEX = /^[0-9]{4}0[0-9]{8}$/;
export const DE_TAX_OFFICE_NUMBER_VALIDATION_REGEX = /^[0-9]{4}$/;

// BE Regex
export const BE_REGISTRATION_NUMBER_REGEX = /^[0-9]{10}$/;
export const BE_VAT_NUMBER_REGEX = /^BE[0-9]{10}$/;

// FR Regex — "FR" + a 2-char key (may be alphanumeric) + 9-digit SIREN
export const FR_VAT_NUMBER_REGEX = /^FR[0-9A-Z]{2}[0-9]{9}$/i;
export const FR_SIRET_REGEX = /^[0-9]{14}$/;
export const FR_SIREN_REGEX = /^[0-9]{9}$/;

// UK Regex
export const UK_REGISTRATION_NUMBER_REGEX = /^(?:\d{1,8}|[A-Z]{2}\d{1,6})$/;
export const UK_VAT_NUMBER_REGEX =
  /^(?:(?:GB|XI)[\s.-]*)?(?:\d{9}|\d{12}|GD[0-4]\d{2}|HA[5-9]\d{2})$/i;

// France Regex
export const NAF_CODE_REGEX = /^\d{2}\.\d{2}[A-Z]$/;

// Switzerland Regex
export const CH_REGISTRATION_NUMBER_REGEX = /^CHE-\d{3}\.\d{3}\.\d{3}$/;
export const CH_VAT_NUMBER_REGEX = /^CHE-\d{3}\.\d{3}\.\d{3} (MWST|TVA|IVA)$/;
